import React from 'react';
import './css/PrivacyPolicy.css';

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy-page">
            <div className="privacy-container">
                <div className="privacy-header">
                    <h1>개인정보처리방침</h1>
                    <p className="privacy-subtitle">부스바월드 개인정보처리방침</p>
                </div>

                <div className="privacy-content">
                    <div className="privacy-intro">
                        <p>
                            부스바 월드(이하 "회사")는 이용자의 개인정보를 중요시하며, 「개인정보 보호법」 등 관련 법령을 준수하고 있습니다. 
                            본 개인정보처리방침은 이용자가 회사의 홈페이지를 이용하면서 제공한 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 
                            회사가 이를 어떻게 보호하고 있는지를 설명합니다.
                        </p>
                    </div>

                    <section className="privacy-section">
                        <h2>제1조(개인정보 수집 항목 및 수집 방법)</h2>
                        
                        <h3>수집 항목</h3>
                        <p>회사는 다음의 개인정보를 수집할 수 있습니다.</p>
                        <ul>
                            <li><strong>필수항목:</strong> 이름, 회사명, 연락처(전화번호, 이메일), 요청내용</li>
                            <li><strong>선택항목:</strong> 부서명, 직급, 주소 등</li>
                        </ul>

                        <h3>수집 방법</h3>
                        <ul>
                            <li>홈페이지 내 견적 요청 및 상담 양식</li>
                            <li>전화, 이메일 또는 기타 수단을 통한 직접 수집</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>제2조(개인정보의 수집 및 이용 목적)</h2>
                        <p>회사는 수집한 개인정보를 다음의 목적을 위해 사용합니다.</p>
                        <ul>
                            <li>제품 견적 제공 및 상담 응대</li>
                            <li>고객 문의 대응 및 기술 지원</li>
                            <li>계약 체결 및 사후관리(A/S 포함)</li>
                            <li>법령상 의무 이행 또는 분쟁 대응</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>제3조(개인정보의 보유 및 이용 기간)</h2>
                        <p>
                            회사는 개인정보 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 
                            단, 관련 법령에 따라 보존이 필요한 경우에는 일정 기간 보관할 수 있습니다.
                        </p>
                        <ul>
                            <li><strong>견적/상담 기록:</strong> 최대 1년간 보유 후 파기</li>
                            <li><strong>계약 체결 시 관련 정보:</strong> 상법 등 관련 법령에 따라 최대 5년간 보유</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>제4조(개인정보의 제3자 제공)</h2>
                        <p>회사는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.</p>
                        <ul>
                            <li>이용자가 사전에 동의한 경우</li>
                            <li>법령에 의해 제출 의무가 있는 경우</li>
                            <li>계약 이행을 위해 필요한 최소한의 범위 내에서 운송사 등에게 제공하는 경우</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>제5조(개인정보의 처리 위탁)</h2>
                        <p>
                            회사는 원활한 서비스 제공을 위하여 개인정보 처리를 외부 전문 업체에 위탁할 수 있으며, 
                            위탁 시 관련 법령에 따라 위탁계약을 체결하고 관리·감독을 철저히 합니다.
                        </p>
                        <p className="note">※ 현재 회사는 개인정보 처리를 외부에 위탁하지 않습니다.</p>
                    </section>

                    <section className="privacy-section">
                        <h2>제6조(정보주체의 권리 및 행사 방법)</h2>
                        <p>이용자는 언제든지 다음과 같은 권리를 행사할 수 있습니다.</p>
                        <ul>
                            <li>개인정보 열람, 정정, 삭제, 처리정지 요청</li>
                            <li>개인정보 수집·이용 동의 철회</li>
                        </ul>
                        <p>
                            위의 권리 행사는 이메일 또는 유선 등을 통해 요청하실 수 있으며, 
                            회사는 이에 대해 지체 없이 조치합니다.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>제7조(개인정보의 파기 절차 및 방법)</h2>
                        <p>
                            회사는 개인정보 보유기간이 경과하거나 처리 목적이 달성된 경우, 
                            지체 없이 해당 정보를 파기합니다.
                        </p>
                        <ul>
                            <li><strong>전자적 파일:</strong> 복구 불가능한 기술적 방법으로 삭제</li>
                            <li><strong>종이 문서:</strong> 분쇄하거나 소각하여 파기</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>제8조(개인정보 보호를 위한 기술적·관리적 대책)</h2>
                        <p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
                        <ul>
                            <li>개인정보에 대한 접근 제한</li>
                            <li>내부관리계획의 수립 및 시행</li>
                            <li>보안 프로그램 설치 및 정기적 점검</li>
                            <li>직원 교육 및 관리</li>
                        </ul>
                    </section>

                    <section className="privacy-section">
                        <h2>제9조(개인정보 보호책임자)</h2>
                        <p>
                            회사는 개인정보 처리에 관한 업무를 총괄하여 책임지고, 
                            정보주체의 민원 처리를 담당하는 개인정보 보호책임자를 지정하고 있습니다.
                        </p>
                        <div className="contact-info">
                            <ul>
                                <li><strong>성명:</strong> 개인정보 보호책임자</li>
                                <li><strong>직책:</strong> 개인정보 보호책임자</li>
                                <li><strong>연락처:</strong> info@busbarworld.com</li>
                            </ul>
                        </div>
                        <p className="note">
                            ※ 개인정보 관련 문의는 언제든지 접수 가능하며, 
                            회사는 신속하고 성실하게 답변해드립니다.
                        </p>
                    </section>

                    <section className="privacy-section">
                        <h2>제10조(개정 사항의 고지)</h2>
                        <p>
                            본 개인정보처리방침은 법령 또는 회사 정책에 따라 변경될 수 있으며, 
                            변경 시 홈페이지를 통해 사전 공지합니다.
                        </p>
                        <p><strong>시행일자:</strong> 2025년 8월 1일</p>
                    </section>
                </div>

                <div className="privacy-footer">
                    <button onClick={() => window.close()} className="close-button">
                        창 닫기
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy; 